// The enum values the browser product events send and the warehouse reads by name.
//
// These strings are a persisted contract. The warehouse marts select them verbatim, so a value
// changed here without a matching warehouse change drops a column to null for every later row.
// Add values; do not rename them.
//
// Browser-safe: constants only, no SDK. Re-exported from index.js.

// portal:shared.share_kind
export const SHARE_KIND = Object.freeze({
  PORTAL: 'portal',
  ITINERARY: 'itinerary',
  PAY: 'pay',
  EXAMPLE: 'example',
  VIDEO: 'video',
});

// workflow:started.workflow
export const WORKFLOW = Object.freeze({
  SHARE: 'share',
  INVOICE: 'invoice',
  IMPORT: 'import',
  BUILD: 'build',
});

// builder:quote_requested.mode
export const QUOTE_MODE = Object.freeze({
  QUOTE_ONLY: 'quote_only',
  UPDATE_BOOKING: 'update_booking',
});

// edge:enquiry_submitted.origin — the control that opened the Edge enquiry.
export const ENQUIRY_ORIGIN = Object.freeze({
  EDGE_DETAIL: 'edge_detail',
  NAVBAR: 'navbar',
});

// video:*.video_player — the player that emitted the event. Hero.tsx is absent: it is decorative and
// fires no video events.
export const VIDEO_SURFACE = Object.freeze({
  CLIENT_V2_CONFIRMATION: 'client_v2_confirmation',
  CLIENT_V2_HERO_VIDEO: 'client_v2_hero_video',
  CLIENT_V2_SHARE: 'client_v2_share',
  EDGE_GALLERY: 'edge_gallery',
});

// proposal:document_downloaded.document_kind — `receipt` is a payment receipt.
export const DOCUMENT_KIND = Object.freeze({
  ITINERARY: 'itinerary',
  RECEIPT: 'receipt',
});
